module.exports = "/images/close.svg?d740dc561bc323e93040890e61d94299";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/close.svg
// module id = mHuK
// module chunks = 1